import { SyncRedactor } from "./../redact/index";

const customRedactors = {
    before: [
        {
            regexpPattern: /\b[A-Z]\d{7}\b/g,
            replaceWith: 'PASSPORT_NUMBER'
        },
        {
            regexpPattern: /(?<=password: )(.*)/gi,
            replaceWith: '[REDACTED]'
        }
    ],
};

// Function to redact PII in text content
function redactTextContent(text: string): string {
    const redactor = new SyncRedactor({
        builtInRedactors: {
            names: {
                replaceWith: 'ANONYMOUS_PERSON'
            }
        },
        customRedactors
    });
    return redactor.redact(text);
}

// Function to recursively find and redact PII in text nodes
function redactPIIInDOM(element: Element) {
    const treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    let currentNode;

    while ((currentNode = treeWalker.nextNode())) {
        const originalText = currentNode.nodeValue as string;
        const redactedText = redactTextContent(originalText);

        if (originalText !== redactedText) {
            currentNode.nodeValue = redactedText;
        }
    }

    // Redact PII in input fields
    redactPIIInInputs(element);
}

// Function to redact PII from passwords in input fields
function redactPIIInInputs(element: Element) {
    const inputs = Array.from(element.querySelectorAll('input[type="password"]'));
    inputs.forEach(input => {
        const passwordInput = input as HTMLInputElement;
        passwordInput.value = '[REDACTED]';
    });
}

export { redactPIIInDOM, redactTextContent };

